import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExpandedCardModal } from '../expanded-card/expanded-card.modal';
import { TranslationsService } from './../../../../translations/translations.service';

@Component({
  selector: 'csi-widget-table-card',
  templateUrl: './widget-table-card.component.html',
  styleUrls: ['./widget-table-card.component.scss']
})
export class WidgetTableCardComponent implements OnInit {
  @Input() card: any;

  columnDefs = [];
  public readonly translocoFileKey = 'dashboard.';
  constructor(private dialog: MatDialog, public translationsService: TranslationsService) {}

  ngOnInit() {
    this.columnDefs = (this.card.content || []).map(col => col.heading);
  }

  public expandCard() {
    ExpandedCardModal.open(this.dialog, this.card);
  }
}
